import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { validation, formfields } from "kea-react"; import { componentToRx } from "app/logic/rx";

import { TurnoList } from "./list/list";
import { TurnoEdit } from "./edit/edit";

export class TurnoCatalogo extends React.Component<{match: match<{}>}> {
    render() {
        const path = this.props.match.path;
        return (
            <div>
                <Route exact path={path}  component={TurnoList} />
                <Route path={path + "/:id"}  component={TurnoEdit} />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/turnos/index.tsx